export enum CurationItemPermissions {
  WRITE_CURATION_ITEM_PERMISSION = 'CURATIONITEM.WRITE',
  PUBLISH_CURATION_ITEM_PERMISSION = 'CURATIONITEM.PUBLISH',
  APPROVE_CURATION_ITEM_PERMISSION = 'CURATIONITEM.APPROVE',
  REVIEW_CURATION_ITEM_PERMISSION = 'CURATIONITEM.REVIEW'
}

export const CurationItemWritePermissionsFilter = 'CURATIONITEM.*.WRITE';
